import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../api'

export const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: apiClient.user.fetchUserInfo,
    staleTime: 1000 * 60 * 60 * 4, // 4 hours - requery frequently to get fresh user data
    gcTime: 1000 * 60 * 60 * 24, // Keep in memory for 24 hours
    retry: (failureCount, error) => {
      return failureCount < 3
    },
  })
}
